import { PressProps, usePress } from '@react-aria/interactions'
import { usePreventScrollClick } from 'hooks/usePreventScrollClick'
import { PressEvent } from '@react-types/shared/src/events'

export const useCarouselPress = ({ onPress: propsOnPress, ...props }: PressProps) => {
  const { handleTouchStart, handleTouchMove, handleTouchEnd, isDragging } = usePreventScrollClick(10)
  const onPress = (event: PressEvent) => {
    if (isDragging) return

    propsOnPress?.(event)
  }

  const { isPressed, pressProps } = usePress({ ...props, onPress })

  return {
    pressProps,
    isPressed,
    onTouchStart: handleTouchStart,
    onTouchMove: handleTouchMove,
    onTouchEnd: handleTouchEnd,
  }
}
